
// Scheduled = 0; InProgress = 1; Paused = 2; Completed = 3; Failed = 4; Canceled = 5;
import {CampaignSetting} from "./dataForDesignCampaign";
import {TemplateContent} from "./templateEditContentList";

export enum CampaignStatus {
    scheduled = 0,
    inProgress = 1,
    paused = 2,
    completed = 3,
    failed = 4,
    canceled = 5,
    all = 999
}

export enum DeliveryStatus {
    created = 1,
    sending = 2,
    success = 3,
    failed = 4,
    reject = 5,
}

export enum CampaignBigType {
    regularCampaign = 0,
    automatedCampaign = 2,
    surveyCampaign = 3,
    none
}

/**
 * @Desc   只对 auto campaign 有意义
 * @Params
 * @Return
*/
export enum AutomatedCampaignType {
    appointment,
    birthday,
    lab,
    appInstallation,
    postAppointment,
    none = 100
}

/**
 * @Desc   只对 regular campaign 有意义, 表示 recurrence 频率
 * @Params
 * @Return
*/
export enum CampaignType {
    sendOnce,
    sendMonthly,
    sendQuarterly,
    sendYearly,
    sendOnPatientBirthday,
    sendWeekly,
    sendBiWeekly,
}

export interface CampaignSummary {
    id: string,
    relationId: string,
    name: string,
    sendDateTime: string,
    status: CampaignStatus,
    type: string,
    campaignBigType: CampaignBigType,
    automatedCampaignType: AutomatedCampaignType,
    campaignType: CampaignType,
    groupName: string,
    patientCount: number,
    sendSuccessCount: number,
    sendFailedCount: number,
    toBeSentCount: number,
    createdBy: string,
}

export interface CampaignDetail {
    setting: CampaignSetting,
    templateContentList: Array<TemplateContent>,
}

export interface CampaignModel {
    summary: CampaignSummary,
    detail: CampaignDetail,
}
